import { Box, FormLabel, forwardRef, Textarea, TextareaProps } from '@chakra-ui/react'

interface ITextAreaProps extends TextareaProps {
  label?: string
  boxMargin?: string
}

const TextArea = forwardRef((props: ITextAreaProps, ref) => {
  const { label, boxMargin } = props

  const TextAreaElement = () => {
    return <Textarea height='full' borderRadius='0' ref={ref} {...props} />
  }

  if (label) {
    return (
      <Box height='full' display='flex' flexDirection='column' margin={boxMargin}>
        <FormLabel fontSize='md'>{label}</FormLabel>
        <TextAreaElement />
      </Box>
    )
  }

  return <TextAreaElement />
})

export { TextArea }
